import React from 'react';
import QrCode from 'react-qr-code';

import { clsx } from 'clsx';

import { useLayoutContext } from '@ott/layout-context';

import MobileAppButtons from 'src/components/blocks/MobileAppBanner/MobileAppButtons';
import FadeIn from 'src/components/elements/FadeIn';
import GradientButton from 'src/components/elements/GradientButton';
import { PhoneFrame } from 'src/components/elements/PhoneFrame';
import { LOGO } from 'src/components/pages/loyalty/SharingPage/constants';

import { getIsMobileUserAgent } from 'src/helpers/getIsMobileUserAgent';

import styles from './MobileBanner.scss';

const DOWNLOAD_LINK = 'https://slr.onelink.me/gEAA/6hlp940t';

const isMobileUserAgent = getIsMobileUserAgent(
  typeof window !== 'undefined' ? window.navigator.userAgent : ''
);

const MobileBanner = () => {
  const { isDesktop } = useLayoutContext();

  const handleClick = () => {
    window.open(DOWNLOAD_LINK, '_blank');
  };

  return (
    <div className={styles.mobileBannerContainer}>
      <FadeIn delay={0.2}>
        <PhoneFrame>
          {isMobileUserAgent ? (
            <img className={styles.logo} src={LOGO.MOBILE} alt="" />
          ) : (
            <div className={styles.phoneContent}>
              <img className={styles.phoneLogo} src={LOGO.DESKTOP} alt="logo" />
              <QrCode value={DOWNLOAD_LINK} className={styles.qrCode} />
            </div>
          )}
        </PhoneFrame>
      </FadeIn>
      <FadeIn delay={0.4}>
        <p className={clsx(styles.title, styles.mobileBannerText)}>
          Change {!isDesktop && <br />}
          <span className={clsx(styles.title, styles.titleThin)}>your travel game</span>
        </p>
      </FadeIn>
      {isDesktop ? (
        <FadeIn delay={0.6}>
          <GradientButton onClick={handleClick} className={styles.mobileButton}>
            Get started
          </GradientButton>
        </FadeIn>
      ) : (
        <MobileAppButtons downloadLink={DOWNLOAD_LINK} />
      )}
    </div>
  );
};

export default MobileBanner;
